import * as React from 'react';
import { FunctionComponent } from 'react';
import { LoadingState } from "@mancala/core";
import { useTranslation } from 'react-i18next';

const LoadingComponent: FunctionComponent<{ loadingState: LoadingState<any> }> = ({ loadingState }) => {

    const { t } = useTranslation();

    if (!loadingState.isLoading() && !loadingState.isError()) return <></>;
    const text = loadingState.isLoading() ? t("Loading") + "..." : loadingState.errorMessage;
    return (
        <div className="loading panel" role="status">
            {loadingState.isLoading() && <span className="dot" />}
            {text}
            <style jsx>{`
                .loading {
                    align-self: center;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 14px 22px;
                    font-weight: 700;
                }
                .dot {
                    color: var(--accent);
                }
            `}</style>
        </div>
    );
}

export default LoadingComponent;
